import {get} from './Tools';

const getAll = async (entity, entityId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}bitacora/${entity}/${entityId}`);
  return response;
};

export { getAll };
